
<FeatureAnnouncementModal
    v-if="currentAnnouncement"
    :show="showModal"
    :announcement="currentAnnouncement"
    @close="handleClose"
    @dismiss="handleDismiss"
    @dont-show-again="handleDontShowAgain"
/>
